import {
  Heading,
  Text,
  Image,
  VStack,
  HStack,
  AspectRatio,
  Tag,
  useToken,
  Box,
} from '@chakra-ui/react';

import formatPriceNumber from '~/utils/formatPriceNumber';

import errorImg from '~/assets/images/image_error.png';

type MealItemCardProps = {
  name?: string;
  tags?: Array<string>;
  description?: string;
  price?: number;
  image?: string;
  disabled?: boolean;
  onNavigate?: () => void;
};

export default function MealItemCard({
  name = '',
  tags = [],
  description = '',
  price = 0,
  image = '',
  disabled = false,
  onNavigate,
}: MealItemCardProps) {
  const [primaryLight] = useToken('colors', ['primaryLight']);

  return (
    <HStack
      py={2}
      borderBottomWidth="1px"
      borderColor="gray.200"
      align="stretch"
      flex={1}
      as={disabled ? 'div' : 'a'}
      onClick={disabled ? () => {} : onNavigate}
      cursor={disabled ? 'auto' : 'pointer'}
      position="relative"
    >
      <VStack
        flex="1"
        align="flex-start"
        justify="space-between"
        overflow="hidden"
        opacity={disabled ? 0.5 : 1}
      >
        <Heading fontSize="md" isTruncated maxW={{ base: '10rem', sm: '20rem', md: '14rem' }}>
          {name}
        </Heading>
        <HStack>
          {tags.map((tag) => (
            <Tag
              key={tag}
              px={3}
              size="md"
              variant="outline"
              color="secondary"
              fontWeight="normal"
              whiteSpace='nowrap'
              boxShadow={`inset 0 0 0 1px ${primaryLight}`}
            >
              {tag}
            </Tag>
          ))}
        </HStack>
        <Text
          fontSize="xs"
          color="gray.500"
          isTruncated
          maxW={{ base: '10rem', sm: '20rem', md: '14rem' }}
        >
          {description}
        </Text>
        <Text>{formatPriceNumber(price)}</Text>
      </VStack>

      {image ? (
        <AspectRatio w="110px" ratio={1} opacity={disabled ? 0.5 : 1}>
          <Image
            src={image}
            fallbackSrc={errorImg}
            loading="lazy"
            borderRadius="base"
            title={name}
          />
        </AspectRatio>
      ) : (
        <Box w="110px" h="110px" opacity={disabled ? 0.5 : 1} />
      )}

      {disabled && (
        <HStack
          position="absolute"
          bottom={'8px'}
          right={0}
          bgColor="gray.400"
          borderRadius="6px"
          p="9.5px 11px"
          height="41px"
          width="110px"
          alignItems="center"
          justifyContent="center"
        >
          <Text
            color="fontColor"
            fontSize="14px"
            fontWeight={100}
            lineHeight="21px"
            letterSpacing="1.4px"
          >
            非供應時間
          </Text>
        </HStack>
      )}
    </HStack>
  );
}
